export default "__VITE_ASSET__a9fd5f26__"